// qs-brushDefaults.ts
export const BRUSH_SIZES = [2, 4, 8, 16, 32]
export const DEFAULT_BRUSH_INDEX = 2
export const DEFAULT_BRUSH_SIZE = BRUSH_SIZES[DEFAULT_BRUSH_INDEX]
export const MAX_BRUSH_ITEMS = 5

export function getBrushDefaults() {
  return {
    sizes: [...BRUSH_SIZES],
    defaultIndex: DEFAULT_BRUSH_INDEX,
    defaultSize: DEFAULT_BRUSH_SIZE,
    maxItems: MAX_BRUSH_ITEMS
  }
}

export function initializeBrushPanel() {
  return {
    brushItems: BRUSH_SIZES.map((size, index) => ({
      id: `brush-item-${index}`,
      size
    })),
    inputValues: [...BRUSH_SIZES],
    selectedIndex: DEFAULT_BRUSH_INDEX,
    selectedSize: DEFAULT_BRUSH_SIZE
  }
}

export function forceSetDefaultBrushSize() {
  window.dispatchEvent(new CustomEvent('reset-brush-sizes'))
  window.dispatchEvent(new CustomEvent('select-brush-by-index', {
    detail: { index: DEFAULT_BRUSH_INDEX }
  }))
  return {
    size: DEFAULT_BRUSH_SIZE,
    index: DEFAULT_BRUSH_INDEX
  }
}